import { getSupabaseClient } from '../../lib/supabase'

export type BetaWorkspace = {
  organization: { id: string; name: string; createdAt: string }
  pilot: { status: string; primary_contact_email: string | null; target_end_on: string | null } | null
  journey: Record<'members'|'properties'|'assessments'|'documents'|'tasks'|'billing'|'amigo', number>
  checks: Array<{ journey: string; status: string; notes: string | null }>
  incidents: Array<{ id: string; severity: string; status: string; title: string }>
  aiConsent: boolean
  errors24h: number
  amigoCostMonth: number
}

export async function getBetaWorkspace(organizationId: string) {
  const supabase = getSupabaseClient()
  const { data, error } = await supabase.rpc('get_beta_launch_workspace', { target_organization_id: organizationId })
  if (error) throw error
  return data as unknown as BetaWorkspace
}

export async function getBetaProgramDashboard() {
  const supabase = getSupabaseClient()
  const { data, error } = await supabase.rpc('get_beta_program_dashboard')
  if (error) throw error
  return data as unknown as Array<Record<string, string|number|null>>
}

export async function isPlatformOperator() {
  const supabase = getSupabaseClient()
  const { data, error } = await supabase.rpc('is_platform_operator')
  if (error) throw error
  return data
}

export async function isGuidedDemoOperator() {
  const supabase = getSupabaseClient()
  const { data, error } = await supabase.rpc('is_guided_demo_operator' as never)
  if (error) throw error
  return data === true
}

export async function acceptAiConsent(organizationId: string) {
  const supabase = getSupabaseClient()
  const { error } = await supabase.rpc('accept_ai_consent', { target_organization_id: organizationId, target_policy_version: '2026-07-22' })
  if (error) throw error
}

export async function seedBetaDemoWorkspace(organizationId: string) {
  const supabase = getSupabaseClient()
  const { data, error } = await supabase.rpc('seed_beta_demo_workspace', { target_organization_id: organizationId })
  if (error) throw error
  return data
}
